import { N77_05 } from "./AgingGeneralSummary/N77_05"
import { N77_03 } from "./AgingSummary/N77_03"
import { N77_02 } from "./CollectionSummary/N77_02"
import { N77_04 } from "./ReceivablesSummary/N77_04"
import { N77_01 } from "./ShareByDistrict/N77_01"
import { N77 } from "./SharebyRegion/N77"

export const ReceivablesReports = {
    "sections": [
        N77_02,
        N77,
        N77_05,
        N77_04,
        N77_03
    ]
}